import { render, staticRenderFns } from "./LongTermUserAdd.vue?vue&type=template&id=c10b4c42&scoped=true&"
import script from "./LongTermUserAdd.vue?vue&type=script&lang=js&"
export * from "./LongTermUserAdd.vue?vue&type=script&lang=js&"
import style0 from "./LongTermUserAdd.vue?vue&type=style&index=0&id=c10b4c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10b4c42",
  null
  
)

export default component.exports